import { render, staticRenderFns } from "./verifySucceeded.vue?vue&type=template&id=56c226e4&scoped=true"
import script from "./verifySucceeded.vue?vue&type=script&lang=js"
export * from "./verifySucceeded.vue?vue&type=script&lang=js"
import style0 from "./verifySucceeded.vue?vue&type=style&index=0&id=56c226e4&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c226e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56c226e4')) {
      api.createRecord('56c226e4', component.options)
    } else {
      api.reload('56c226e4', component.options)
    }
    module.hot.accept("./verifySucceeded.vue?vue&type=template&id=56c226e4&scoped=true", function () {
      api.rerender('56c226e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claimWorkOrder/setCollectAccountByQuick/verifySucceeded.vue"
export default component.exports